import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/modules/administracion/auth';

/**
 * PrivateRoute - Protección de rutas basada en autenticación
 * 
 * DECISIÓN ARQUITECTÓNICA (P2 - 2025-12-20):
 * 
 * ✅ Frontend SOLO verifica autenticación (isAuthenticated)
 * ❌ Frontend NO decide autorización/permisos
 * 
 * AUTORIZACIÓN se maneja en:
 * 1. Backend: Retorna 403 Forbidden si usuario no tiene permisos
 * 2. Páginas: Manejan error.status === 403 y muestran UnauthorizedPage
 * 
 * ¿Por qué NO validamos roles aquí?
 * - Frontend puede ser manipulado (localStorage, DevTools)
 * - Información sensible (roles) no debe decidir en cliente
 * - Regla de negocio debe estar SOLO en backend
 * - Frontend es para UX, backend para seguridad
 * 
 * Patrón correcto:
 * ```tsx
 * const UsuariosPage = () => {
 *   const { data, error } = useQuery(['usuarios'], fetchUsuarios);
 *   
 *   if (error?.status === 403) {
 *     return <UnauthorizedPage message="No tienes permisos" />;
 *   }
 *   
 *   return <UsuariosList data={data} />;
 * };
 * ```
 */

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
